
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ControlMedia from './control-media'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "controlmedia"
    }}>{`ControlMedia`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "media-play"
    }}>{`Media (play)`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For playing media. Useful where the control may overlap other objects.`}</p>
    <Playground __position={1} __code={'<ControlMedia />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} mdxType="Playground">
  <ControlMedia mdxType="ControlMedia" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={2} __code={'<ControlMedia disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} mdxType="Playground">
  <ControlMedia disabled mdxType="ControlMedia" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "media-inverse-play"
    }}>{`Media (inverse, play)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For playing media. Useful where the control may overlap other objects.`}</p>
    <Playground __position={4} __code={'<ControlMedia inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlMedia inverse mdxType="ControlMedia" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={5} __code={'<ControlMedia inverse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlMedia inverse disabled mdxType="ControlMedia" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "media-pause"
    }}>{`Media (pause)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For pausing media. Useful where the control may overlap other objects.`}</p>
    <Playground __position={7} __code={'<ControlMedia controlType=\"pause\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} mdxType="Playground">
  <ControlMedia controlType='pause' mdxType="ControlMedia" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={8} __code={'<ControlMedia controlType=\"pause\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} mdxType="Playground">
  <ControlMedia controlType='pause' disabled mdxType="ControlMedia" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "media-inverse-pause"
    }}>{`Media (inverse, pause)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For pausing media. Useful where the control may overlap other objects.`}</p>
    <Playground __position={10} __code={'<ControlMedia inverse controlType=\"pause\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlMedia inverse controlType='pause' mdxType="ControlMedia" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={11} __code={'<ControlMedia inverse disabled controlType=\"pause\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlMedia inverse disabled controlType='pause' mdxType="ControlMedia" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "media-stop"
    }}>{`Media (stop)`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`For stopping media. Useful where the control may overlap other objects.`}</p>
    <Playground __position={13} __code={'<ControlMedia controlType=\"stop\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} mdxType="Playground">
  <ControlMedia controlType='stop' mdxType="ControlMedia" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={14} __code={'<ControlMedia controlType=\"stop\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} mdxType="Playground">
  <ControlMedia controlType='stop' disabled mdxType="ControlMedia" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "media-inverse-stop"
    }}>{`Media (inverse, stop)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`For stopping media. Useful where the control may overlap other objects.`}</p>
    <Playground __position={16} __code={'<ControlMedia inverse controlType=\"stop\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlMedia inverse controlType='stop' mdxType="ControlMedia" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={17} __code={'<ControlMedia inverse disabled controlType=\"stop\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlMedia
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlMedia inverse disabled controlType='stop' mdxType="ControlMedia" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ControlMedia} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;